var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyItem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 143,
    viewBox: "0 0 180 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10473_49695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.4258,
    y: 38.4053,
    width: 67.8881,
    height: 67.8881,
    rx: 8,
    transform: "rotate(-18.16 53.4258 38.4053)",
    stroke: "#D9DBE4",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeDasharray: "6 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7695 30.7667L84.6902 51.8658C85.3788 53.9649 87.6386 55.1084 89.7377 54.4199L98.1432 51.6628C100.242 50.9742 101.386 48.7144 100.697 46.6153L93.7766 25.5163",
    stroke: "#D9DBE4",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeDasharray: "6 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.728 3.69703C122.953 3.04617 123.665 2.69629 124.296 2.97071C124.928 3.24513 125.158 4.00448 124.835 4.61283L122.224 9.53777C122.052 9.86286 121.65 9.9842 121.312 9.83755C120.975 9.6909 120.789 9.31393 120.909 8.96612L122.728 3.69703ZM131.133 11.1332C131.752 10.8312 132.504 11.0872 132.757 11.7284C133.01 12.3696 132.635 13.0698 131.976 13.2717L126.645 14.9056C126.294 15.0129 125.926 14.8148 125.792 14.474C125.657 14.1331 125.791 13.7368 126.121 13.5763L131.133 11.1332ZM111.526 4.3851C111.224 3.76557 111.48 3.01361 112.121 2.76087C112.762 2.50813 113.462 2.8832 113.664 3.54217L115.298 8.87328C115.405 9.22356 115.207 9.59211 114.866 9.72646C114.526 9.86081 114.129 9.72658 113.969 9.39725L111.526 4.3851Z",
    fill: "#D9DBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4319 22.8653C37.1812 16.6818 31.7633 12.0976 25.293 10.9013L23.8399 11.7227L22.5723 19.4692L23.5009 20.5955C26.5519 21.1593 29.1066 23.3211 30.1678 26.237L57.5042 101.343L59.5911 103.15L65.6004 101.343L66.7144 97.8238L39.4319 22.8653Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.98 88.949C150.049 86.3907 147.22 85.0716 144.662 86.0029L86.2667 107.18L85.1309 109.727L86.2667 114.986L89.2983 116.568L148.034 95.267C150.592 94.3357 151.911 91.507 150.98 88.949Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82602 7.3026C3.1488 6.80768 0.577938 8.57709 0.0830162 11.2538C-0.411906 13.9307 1.35696 16.5019 4.03364 16.9968L23.5013 20.5958L25.2931 10.9016L5.82602 7.3026Z",
    fill: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1171 138.132C80.2878 138.132 89.3435 129.076 89.3435 117.905C89.3435 106.735 80.2878 97.6788 69.1171 97.6788C57.9463 97.6788 48.8906 106.735 48.8906 117.905C48.8906 129.076 57.9463 138.132 69.1171 138.132Z",
    fill: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1165 128.821C75.1449 128.821 80.0319 123.934 80.0319 117.905C80.0319 111.877 75.1449 106.99 69.1165 106.99C63.0881 106.99 58.2012 111.877 58.2012 117.905C58.2012 123.934 63.0881 128.821 69.1165 128.821Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10473_49695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 141.772,
    fill: "white",
    transform: "translate(0 0.613892)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyItem);
export default __webpack_public_path__ + "static/media/icon-empty-item.f42c9e77a6cfedf4538b955cf6a08b06.svg";
export { ForwardRef as ReactComponent };